import { render, staticRenderFns } from "./PositionHistoryNew.vue?vue&type=template&id=fb2cfc64&scoped=true&lang=pug&"
import script from "./scripts/PositionHistoryNew.js?vue&type=script&lang=js&"
export * from "./scripts/PositionHistoryNew.js?vue&type=script&lang=js&"
import style0 from "./PositionHistoryNew.vue?vue&type=style&index=0&id=fb2cfc64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2cfc64",
  null
  
)

export default component.exports